/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	Col,
	Container,
	Form,
	FormGroup,
	Input,
	Label,
	Row,
	UncontrolledTooltip,
	NavLink,
	Modal,
} from 'reactstrap';

import ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-table/react-table.css';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import PesquisaRapida from '../Common/PesquisaRapida';
import PrettyCheckbox from '../Common/PrettyCheckbox';
import TooltippedCel from '../Common/TooltippedCel';

import { ModalUploadContext } from '../../Providers/ModalUpload';
import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import EmissoesErro from '../Modais/EmissoesErro';
import EmissoesExclusao from '../Modais/EmissoesExclusao';
import EmissoesExclusaoTodos from '../Modais/EmissoesExclusaoTodos';
import Pagination from '../../Util/Pagination';

import { getVal, formataCurrency } from '../../BaseFunctions';

import './Pendentes.scss';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';
const isPro = localStorage.getItem('isPro') === 'true';

const getStoredPageSize = () => {
	const stored = localStorage.getItem('gnre_pageSize');
	return stored ? parseInt(stored) : 20;
};

Object.assign(ReactTableDefaults, {
	pageSizeOptions: [20, 25, 50, 100],
	defaultPageSize: 20,
    pageSize: 20,
	minRows: 20,
	//maxRows: 30,
	nextText: 'Próxima',
	// previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pág.',
	ofText: 'de',
	rowsText: 'linhas',
});

function Pendentes() {
	const [rawData, setRawData] = useState([]);
	const [showData, setShowData] = useState([]);
	const [showDataPagination, setShowDataPagination] = useState([]);
	const [termoAceito, setTermoAceito] = useState(false);
	const [emissoesErro, setEmissoesErro] = useState({});
	const [strBusca, setStrBusca] = useState('');
	const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
	const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
	const [urlHomo, setUrlHomo] = useState("");
	const [pageData, setDataPage] = useState('');
	const [totalCount, setTotalCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [sortConfig, setSortConfig] = useState({ sortBy: '', sortDirection: 'asc' });
	const [filterEmitente, setFilterEmitente] = useState('');
	const [filterUf, setFilterUf] = useState('');
	const [filterBusca, setFilterBusca] = useState('');
	const [allIds, setAllIds] = useState([]);
	const [pageSize, setPageSize] = useState(getStoredPageSize());
	const debounceTimer = useRef(null);

	let reactTable = React.createRef();
	let ModalEmissoesErro = React.createRef();
	let ModalEmissoesExclusao = React.createRef();
	let ModalEmissoesExclusaoTodos = React.createRef();

	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	let openModalUpload;
	/* eslint-enable no-unused-vars */

	useEffect(() => {
		setTermoAceito(localStorage.getItem('TermoUso') === 'true');
		if (localStorage.getItem('notificarEnvio') === 'true') {
			showSuccessMessage('Arquivos enviados com sucesso!');
		}
		localStorage.setItem('notificarEnvio', false);

		handleReload();

		if (window.location.hostname == "ec2-34-206-89-100.compute-1.amazonaws.com") {
			setUrlHomo("http://www.testegnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		} else {
			setUrlHomo("http://www.gnre.pe.gov.br:444/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		}
	}, []);

	useEffect(() => {
		if (allIds.length > 0 && ModalEmissoesExclusaoTodos.current) {
			ModalEmissoesExclusaoTodos.current.openModal();
		}
	}, [allIds]);

	const handleReload = (page = 1, overrideFilters = {}) => {
		onLoading(true);

		const primeiroAcesso =
			localStorage.getItem('PrimeiroAcesso') && localStorage.getItem('PrimeiroAcesso').toLowerCase() === 'true';

		const params = new URLSearchParams({
			page: page,
			pageSize: overrideFilters.pageSize !== undefined ? overrideFilters.pageSize : pageSize,
			sortBy: overrideFilters.sortBy !== undefined ? overrideFilters.sortBy : sortConfig.sortBy,
			sortDirection: overrideFilters.sortDirection !== undefined ? overrideFilters.sortDirection : sortConfig.sortDirection,
			filterEmitente: overrideFilters.filterEmitente !== undefined ? overrideFilters.filterEmitente : filterEmitente,
			filterUf: overrideFilters.filterUf !== undefined ? overrideFilters.filterUf : filterUf,
			filterBusca: overrideFilters.filterBusca !== undefined ? overrideFilters.filterBusca : filterBusca
		});

		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarPendentesPaginado?${params}`)
			.then(response => {
				onLoading(false);

				const { data } = response;

				if (termoAceito === true) {
					if (!data.Items.length && window.location.pathname === '/' && !primeiroAcesso) openModalUpload();
				}

				const rawData = data.Items.map(original => ({ ...original, blSelected: false }));
				setRawData(rawData);
				setShowData(rawData);
				setShowDataPagination(rawData);
				setTotalCount(data.TotalCount);
				setCurrentPage(data.Page);
			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao carregar dados');
				setRawData([]);
				setShowData([]);
			});
	};

	const onUpdatePesquisaRapida = (data, strBuscaValue, blShow) => {
		setStrBusca(strBuscaValue);
		setBlShowPesquisaRapida(blShow);
		setFilterBusca(strBuscaValue);
		if (debounceTimer.current) clearTimeout(debounceTimer.current);
		debounceTimer.current = setTimeout(() => {
			handleReload(1, { filterBusca: strBuscaValue });
		}, 500);
	};

	const textFilterMethod = (filter, row) =>
		row[filter.id] && row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

	const childPaginationValue = (page) => {
		setDataPage(page);
	}

	const handleTableSelectAllChange = ({ target: { checked } }) => {
		const firstPageIndex = (pageData - 1) * pageSize;
		const lastPageIndex = firstPageIndex + pageSize;

		const dadosLista = showData.slice(firstPageIndex, lastPageIndex);

		let listaPaginada = dadosLista.map(original => ({ ...original, blSelected: checked }))

		const valor = rawData.map( row => {
			listaPaginada.map(el => {
				if (row.id == el.id){
					row.blSelected = el.blSelected;
				}
			});
			return row;
		});

		setShowDataPagination(valor);

		setShowDataPagination(valor.map(original => ({ ...original, blSelected: checked })));

		//setShowData(showData.map(original => ({ ...original, blSelected: checked })));
	};

	const handleTableSelectChange = (row, target) => {
		setShowData([
			...showData.slice(0, row.index),
			{ ...row.original, [target.name]: target.checked },
			...showData.slice(row.index + 1),
		]);
	};

	const emitirGuias = () => {
		var ids = showData
			.map(item => item.blSelected && !necessitaDetalhes(item) && item.id)
			.filter(item => typeof item !== undefined && item);

		if (ids.length) {
			onLoading(true);
			HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/EmitirGuia`, ids)
				.then(response => {
					var erros = response.data.filter(item => item.Erro != null && item);

					onLoading(false);

					if (!erros.length) {
						window.location.href = '/emitidas';
					} else {
						window.location.href = '/rejeitadas';
					}
				})
				.catch(() => {
					handleReload(false);
				});
		}
	};

	const mostrarErros = id => {
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarErrosEmissao/` + id).then(response => {
			setEmissoesErro({
				strCodigoErro: response.data.strCodigoErro,
				strErro: response.data.strErro,
			});

			setImmediate(() => ModalEmissoesErro.current.openModal());
		});
	};

	const gravarProduto = (idProduto, row) => {
		let formData = new FormData();
		formData.append('idDocumento', row.id);
		formData.append('codigoProduto', idProduto);

		onLoading(true);
		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/SalvarProduto`, formData)
			.then(() => {
				setBlFiltroAtivo(false);
				setStrBusca('');
				onLoading(false);
				handleReload(currentPage);
			})
			.catch(() => {
				onLoading(false);
			});
	};

	const gravarDetalhamento = (idDetalhamento, row) => {
		let formData = new FormData();
		formData.append('idDocumento', row.id);
		formData.append('codigoDetalhamento', idDetalhamento);

		onLoading(true);
		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Documento/SalvarDetalhamento`, formData)
			.then(() => {
				setBlFiltroAtivo(false);
				setStrBusca('');
				onLoading(false);
				handleReload(currentPage);
			})
			.catch(() => {
				onLoading(false);
			});
	};

	const mostrarProdutos = row => {
		if (row.original.status !== 'Erro') {
			return (
				<Container fluid className="sub-component">
					<Row>
						<Col>
							<Form>
								{row.original.listProduto && row.original.listProduto.length ? (
									<FormGroup>
										<Label for={`select-produto${row.original.id}`}>Produto</Label>
										<Input
											value={row.original.codigoProduto || ''}
											bsSize="sm"
											type="select"
											name="select"
											id={`select-produto${row.original.id}`}
											// disabled={isSimulacao || blFiltroAtivo || strBusca.length > 0}
											disabled={isSimulacao || strBusca.length > 0}
											onChange={e => {
												gravarProduto(e.target.value, row.original);
											}}>
											<option value="0">Selecione...</option>
											{row.original.listProduto.map(item => (
												<option key={item.codigo} value={item.codigo}>
													{item.descricao}
												</option>
											))}
										</Input>
									</FormGroup>
								) : null}

								{row.original.listDetalhamento && row.original.listDetalhamento.length ? (
									<FormGroup>
										<Label for={`select-detalhamento${row.original.id}`}>
											Detalhamento da receita
										</Label>
										<Input
											value={row.original.codigoDetalhamento || ''}
											type="select"
											name="select"
											// disabled={isSimulacao || blFiltroAtivo || strBusca.length > 0}
											disabled={isSimulacao || strBusca.length > 0}
											id={`select-detalhamento${row.original.id}`}
											onChange={e => {
												gravarDetalhamento(e.target.value, row.original);
											}}>
											<option value="todos">Selecione...</option>
											{row.original.listDetalhamento.map(item => (
												<option key={item.codigo} value={item.codigo}>
													{item.descricao}
												</option>
											))}
										</Input>
									</FormGroup>
								) : null}
							</Form>
						</Col>
					</Row>
				</Container>
			);
		}
	};

	const necessitaDetalhes = ({ listDocumentosFiscais }) =>
		listDocumentosFiscais && listDocumentosFiscais.some(
			documento =>
				(documento.listProduto && documento.listProduto.length && !documento.codigoProduto) ||
				(documento.listDetalhamento && documento.listDetalhamento.length && !documento.codigoDetalhamento),
		);

	const mostrarInformacoes = row => {
		if (row.original.status === 'Erro') {
			return (
				<span className="nav-item" onClick={() => mostrarErros(row.original.id)}>
					<i className="fas fa-exclamation-triangle text-info" /> Erro
				</span>
			);
		} else if (necessitaDetalhes(row.original)) {
			return 'Necessita det.';
		} else if (row.original.status === 'Indisponivel') {
			return (
				<span className="uf-indisponivel">
					<div>{row.original.uf}</div>
					Indisponível
				</span>
			);
		} else {
			return 'Processando';
		}
	};

	const mostrarDestacados = (row, valor, tooltip = false) => (
		<div style={necessitaDetalhes(row.original) ?
			{ color: '#f58314', fontWeight: 'bold' } :
			valor == "Processando" ?
			{ color: '#79bd28', fontWeight: 'bold' }
			: {}}>

			{tooltip ? <TooltippedCel text={valor} /> : valor}
		</div>
	);

	const renderDocumentosFiscais = row => {
		const listDocumentosFiscais = getVal(row, 'original.listDocumentosFiscais') || [];

		const columnsDocFiscais = [
			{
				Header: () => <div>&nbsp;</div>,
				expander: true,
				// eslint-disable-next-line react/prop-types
				Expander: ({ isExpanded, ...row }) => (
					<div>
						{row.original.status !== 'Erro' &&
						((row.original.listProduto && row.original.listProduto.length) ||
							(row.original.listDetalhamento && row.original.listDetalhamento.length)) ? (
							isExpanded ? (
								<span className="rt-expander -open" />
							) : (
								<span className="rt-expander" />
							)
						) : (
							<span />
						)}
					</div>
				),
				getProps: (state, row) =>
					row.original.status !== 'Erro' &&
					((row.original.listProduto && row.original.listProduto.length) ||
						(row.original.listDetalhamento && row.original.listDetalhamento.length))
						? {}
						: { className: 'no-pointer-events', onClick: () => {} },
			},
			{
				Header: () => <div className="text-left">N. DOCUMENTO</div>,
				accessor: 'strDocumento',
				className: 'text-left',
				width: 100,
				Cell: row => (row.value && row.value.length >= 35 ? parseInt(row.value.substring(25, 34)) : row.value),
			},
			{
				Header: () => <div className="text-left">TIPO</div>,
				accessor: 'strTipoNota',
				className: 'text-left',
				width: 50,
			},
			{
				Header: () => <div className="text-left">DESTINATÁRIO</div>,
				accessor: 'strDestinatario',
				className: 'text-left',
				Cell: row => <TooltippedCel text={row.value} />,
			},
			{
				Header: 'RECEITA',
				accessor: 'strReceita',
				className: 'text-center',
				width: 80,
			},
			{
				Header: 'FCP',
				accessor: 'receitaFcp',
				className: 'text-center',
				width: 60,
				Cell: row => {
					const infoFCP_id = `info-fcp-id-${row.original.id}-${row.index}`;
					return (
						<div>
							{row.value}
							{row.original.receitaFcp === 'Não' && row.original.vlFCP > 0 ? (
								<span>
									&nbsp;
									<i id={infoFCP_id} className="fas fa-info-circle text-info" />
									<UncontrolledTooltip placement="right" target={infoFCP_id}>
										A guia de FCP deverá ser emitida diretamente no Portal da SEFAZ
									</UncontrolledTooltip>
								</span>
							) : null}
						</div>
					);
				},
			},
			{
				Header: 'PRINCIPAL',
				accessor: 'vlPrincipal',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'MULTA',
				accessor: 'vlMulta',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'JUROS',
				accessor: 'vlJuros',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'VALOR TOTAL',
				accessor: 'vlValor',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 150,
			},
		];

		return (
			<Card className="documentos-fiscais">
				<CardHeader>DOCUMENTOS FISCAIS</CardHeader>
				<CardBody>
					<ReactTable
						data={listDocumentosFiscais}
						filterable={false}
						columns={columnsDocFiscais}
						showPagination={false}
						defaultSorted={[{ id: 'strEmitente', desc: false }]}
						minRows={1}
						SubComponent={row => mostrarProdutos(row)}
						collapseOnDataChange={false}
					/>
				</CardBody>
			</Card>
		);
	};

	const columns = [
		{
			Header: () => <div />,
			expander: true,
			// eslint-disable-next-line react/prop-types
			Expander: ({ isExpanded }) => (
				<div>{isExpanded ? <i className="fas fa-minus" /> : <i className="fas fa-plus" />}</div>
			),
		},
		{
			Header: () => (
				<PrettyCheckbox
					strTitle="Essa opção seleciona todos os documentos existentes nesse grupo e não somente a quantidade exibida."
					checked={showDataPagination.every(original => original.blSelected)}
					id="selectAll"
					onChange={e => handleTableSelectAllChange(e)}
					iconSuccess="fas fa-check-double"
					simpleSelection
				/>
			),
			accessor: 'blSelected',
			Cell: row => (
				<PrettyCheckbox
					strTitle="Selecionar"
					checked={row.original.blSelected}
					id="blSelected"
					onChange={({ target }) => handleTableSelectChange(row, target)}
					iconSuccess="fas fa-check"
					simpleSelection
				/>
			),
			filterable: false,
			sortable: false,
			className: 'text-center',
			width: 35,
		},
		{
			Header: () => <div className="text-left">Emitente</div>,
			accessor: 'razaoSocialEmissor',
			filterMethod: textFilterMethod,
			className: 'text-left',
			Cell: row => mostrarDestacados(row, row.value, false),
		},
		{
			Header: 'UF',
			accessor: 'uf',
			filterMethod: textFilterMethod,
			className: 'text-center',
			width: 50,
		},
		{
			Header: () => <div className="text-right">Valor total</div>,
			accessor: 'valorTotal',
			filterMethod: (filter, row) => row[filter.id] && row[filter.id].toString().includes(filter.value),
			className: 'text-right',
			width: 100,
			Cell: row => mostrarDestacados(row, formataCurrency(row.value)),
		},
		{
			Header: 'Informações',
			className: 'text-center',
			filterable: false,
			width: 120,
			Cell: row => <div className="text-center">{mostrarDestacados(row, mostrarInformacoes(row))}</div>,
		},
	];

	return (
		<main id="pendentes">
			<EmissoesErro ref={ModalEmissoesErro} value={emissoesErro} onClosed={handleReload} />
			<EmissoesExclusao
				ref={ModalEmissoesExclusao}
				value={showData.filter(x => x.blSelected).map(x => x.id)}
				onClosed={handleReload}
			/>
			<EmissoesExclusaoTodos
				ref={ModalEmissoesExclusaoTodos}
				value={allIds.length > 0 ? allIds : showData.map(x => x.id)}
				status={0}
				onClosed={() => { setAllIds([]); handleReload(); }}
			/>
			<ModalUploadContext.Consumer>
				{modalUpload => {
					openModalUpload = modalUpload.openModal;
					modalUpload.onClosed = handleReload;
				}}
			</ModalUploadContext.Consumer>
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>
			<Row noGutters id="main-header">
				<Col>
					{/* <Row>
						<Col className="alert alert-danger" style={{padding: "20px"}}>
							<strong>AVISO</strong>:O Portal Nacional da GNRE, que é hospedado na SEFAZ/PE, estará indisponível até 07/02/2025 às 15h.
							Enquanto isto, a emissão pode ser realizada através do link: <a href="https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_Principal.jsp">https://www.gnre.pe.gov.br:444/gnre/portal/GNRE_Principal.jsp</a>
						</Col>
					</Row> */}
					
					<Row style={{ display: 'flex', 'justify-content': 'space-between', 'align-items': 'center', 'flex-wrap': 'wrap', padding: '10px', gap: '10px' }}>
						<Col style={{ flex: '0.7 1 0%', 'min-width': '100px' }}>
							<h1>Guias pendentes</h1>
						</Col>
						{/* <Col style={{ flex: '2 1 0%', 'min-width': '100px' }}>
							<NavLink
								href="https://auditor.econeteditora.com.br/validar-login"
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								Para gerar a <b>GNRE por Apuração</b>, favor auditar o arquivo TXT através do <b>Auditor Fiscal</b>
							</NavLink>
						</Col>
						<Col style={{ flex: '1 1 0%', 'min-width': '100px' }}>
							<NavLink
								href={urlHomo}
								className="btn btn-secondary"
								target="_blank"
								style={{ padding: '4px 10px 1px 10px', fontSize: 'small' }}>
								<>Verificar disponibilidade de emissão por UF </>
								<i className="fas fa-info-circle" />
							</NavLink>
						</Col> */}
					</Row>

					<Row noGutters>
						<Col className="singleHeaderHeight">
							<Row>
								<Col xs="auto p-0">
									<Button
										size="sm"
										color="primary"
										block
										onClick={() => emitirGuias()}
										disabled={
											!isSimulacao
												? !showData.some(original =>
														original.blSelected ? !necessitaDetalhes(original) : false,
												  )
												: true
										}>
										<i className="fas fa-share-square" /> Emitir guias
									</Button>
								</Col>
								<Col xs="auto p-0">
									<Button
										onClick={() => ModalEmissoesExclusao.current.openModal()}
										size="sm"
										color={`base-class ${
											showData.some(original => original.blSelected)
												? 'btn-info'
												: 'btn-secondary'
										}`}
										block
										disabled={
											!isSimulacao && !isPro
												? !showData.some(original => original.blSelected)
												: true
										}>
										<i className="fas fa-trash-alt" /> Excluir
									</Button>
								</Col>
								<Col xs="auto p-0">
									<Button
										onClick={() => {
											const params = new URLSearchParams({ filterEmitente: filterEmitente, filterUf: filterUf, filterBusca: filterBusca });
											HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarIdsPendentes?${params}`)
												.then(response => {
													setAllIds(response.data);
												});
										}}
										size="sm"
										color={`base-class ${
											showData.some(original => original.blSelected)
												? 'btn-danger'
												: 'btn-danger'
										}`}
										block
										disabled={
											showData.length > 0
												? false
												: true
										}
										>
										<i className="fas fa-trash-alt" /> Excluir Todas as Guias
									</Button>
								</Col>
							</Row>
						</Col>
						<Col xs="6" className="singleHeaderHeight mobile-buttons">
							{blShowPesquisaRapida ? (
								<PesquisaRapida
									value={strBusca}
									blShow={blShowPesquisaRapida}
									rawData={rawData}
									onUpdate={onUpdatePesquisaRapida}
								/>
							) : (
								<Container className="p-0">
									<Row>
										<Col />
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlFiltroAtivo(!blFiltroAtivo);
													setShowData(rawData);
													setStrBusca('');
												}}
												color="link">
												<i className="ecoico ecoico-filtro" />
											</Button>
										</Col>
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlShowPesquisaRapida(true);
													setBlFiltroAtivo(false);
												}}
												color="link">
												{strBusca ? (
													<i className="fas fa-search-plus" />
												) : (
													<i className="fas fa-search" />
												)}
											</Button>
										</Col>
									</Row>
								</Container>
							)}
						</Col>
					</Row>
				</Col>
			</Row>
			<Row noGutters>
				<Col>
					<ReactTable
						className="table-pendentes"
						ref={reactTable}
						data={showData}
						filterable={blFiltroAtivo}
						selectRow={{ mode: 'checkbox' }}
						columns={columns}
						manual
						pages={Math.ceil(totalCount / pageSize)}
						page={currentPage - 1}
						showPagination={totalCount > 0}
						showPageSizeOptions={false}
						defaultSorted={[{ id: 'intNFE', desc: false }]}
						PaginationComponent={Pagination}
						childPaginationValue={childPaginationValue}
						onPageChange={(pageIndex) => {
							handleReload(pageIndex + 1);
						}}
						onSortedChange={(newSorted) => {
							if (newSorted.length > 0) {
								setSortConfig({
									sortBy: newSorted[0].id,
									sortDirection: newSorted[0].desc ? 'desc' : 'asc'
								});
								handleReload(1);
							}
						}}
						onFilteredChange={(filtered) => {
							let newFilterEmitente = '';
							let newFilterUf = '';
							filtered.forEach(f => {
								if (f.id === 'razaoSocialEmissor') newFilterEmitente = f.value;
								if (f.id === 'uf') newFilterUf = f.value;
							});
							setFilterEmitente(newFilterEmitente);
							setFilterUf(newFilterUf);
							if (debounceTimer.current) clearTimeout(debounceTimer.current);
							debounceTimer.current = setTimeout(() => {
								handleReload(1, { filterEmitente: newFilterEmitente, filterUf: newFilterUf });
							}, 500);
						}}
						SubComponent={row => renderDocumentosFiscais(row)}
						collapseOnDataChange={false}
						pageSize={pageSize}
						onPageSizeChange={(newSize) => {
							setPageSize(newSize);
							handleReload(1, { pageSize: newSize });
						}}
						strTableInfo={`${totalCount} Guias`}
					/>
				</Col>
			</Row>
		</main>
	);
}

export default withRouter(Pendentes);
